import {
	IEquationBracket,
	IEquationFields,
	IEquationOperator,
	IEquationVariable,
	IOrganizationEvaluationLHSEquationDetail,
	IOrganizationEvaluationRHSEquationDetail,
} from "models/EquationModel";
import { BaseService } from "./base.service";

class EquationServiceInternal extends BaseService {
	getEquationBracketList = async (): Promise<IEquationBracket[]> =>
		this.callApi<IEquationBracket[]>(
			`EquationBracket/GetEquationBracketList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);

	getEquationFieldList = async (): Promise<IEquationFields[]> =>
		this.callApi<IEquationFields[]>(
			`EquationField/GetEquationFieldList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);

	getEquationOperationList = async (): Promise<IEquationOperator[]> =>
		this.callApi<IEquationOperator[]>(
			`EquationOperation/GetEquationOperationList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);

	getEquationVariableList = async (): Promise<IEquationVariable[]> =>
		this.callApi<IEquationVariable[]>(
			`EquationVariable/GetEquationOperationList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);

	saveUpdateEvaluationLHSEquation = async (
		model: IOrganizationEvaluationLHSEquationDetail
	): Promise<number> => {
		return this.callApi<number>(
			`OrganizationPriceEvaluationLhs/SaveUpdate`,
			"POST",
			undefined,
			model
		);
	};

	saveUpdateEvaluationRHSEquation = async (
		model: IOrganizationEvaluationRHSEquationDetail
	): Promise<number> => {
		return this.callApi<number>(
			`OrganizationPriceEvaluationRhs/SaveUpdate`,
			"POST",
			undefined,
			model
		);
	};

	deleteOrganizationPriceEvaluationRhs = async (
		organizationPriceEvaluationRhsId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`OrganizationPriceEvaluationRhs/Delete/${organizationPriceEvaluationRhsId}`,
			"DELETE"
		);

	getOrganizationPriceEvaluationRhs = async (
		organizationPriceEvaluationRhsId: number
	): Promise<IOrganizationEvaluationRHSEquationDetail> => {
		return this.callApi<IOrganizationEvaluationRHSEquationDetail>(
			`OrganizationPriceEvaluationRhs/GetById/${organizationPriceEvaluationRhsId}`,
			"GET",
			undefined,
			undefined
		);
	};
}

export const EquationService = new EquationServiceInternal();
